$(function() {

  // links to PDF files
  var industryFactsheet = $("a[href$='.pdf']:not(.external)");

  // "Automotive" etc (read from breadcrumb)
  var primaryCategory = $(".breadcrumbs > a").attr("title");

  // "AUTOMOTIVE REFINISHING" etc (read from the header banner)
  var secondaryCategory = $(".banner__title").text();

  // the PDF file name
  var pdfName = "";

  // select the table cells with the level, duration and fee
  // need to remove the line breaks with replace()
  var trainingLevel = $("td:eq(6)").text().replace(/(\r\n|\n|\r)/gm, "");
  var duration = $("td:eq(7)").text().replace(/(\r\n|\n|\r)/gm, "");
  var trainingFee = $("td:eq(8)").text().replace(/(\r\n|\n|\r)/gm, "");

  industryFactsheet.on('click', function (event) {

    // get the pdf file name from the event
    pdfName = event.target.href.replace(/^.*[\\\/]/, '');

    dataLayer.push({
      'event': 'pdfDownload',
      'businessCategory': 'Student',
      'primaryCategory': primaryCategory,
      'secondaryCategory': secondaryCategory,
      'pdfName': pdfName, 
      'trainingLevel': trainingLevel,
      'duration': duration,
      'trainingFee': trainingFee
    });
  });


});